// extracted by mini-css-extract-plugin
export default {"container":"images-block_container__37_7V","grid":"images-block_grid__R5ljy","items":"images-block_items__2b7TV","block":"images-block_block__187zp"};